import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class EmployeeIncrementDetailsDto implements IEmployeeIncrementDetailsDto {
    employee!: EmployeeSummaryDto;
    empLegalName!: string | undefined;
    branch!: string | undefined;
    location!: string | undefined;
    department!: string | undefined;
    designation!: string | undefined;
    oldSalary!: number | undefined;
    newSalary!: number | undefined;
    effectiveDate!: Date | undefined;
    incrementPercentage!: number | undefined;

    constructor(data?: IEmployeeIncrementDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.empLegalName = _data["empLegalName"];
            this.branch = _data["branch"];
            this.location = _data["location"];
            this.department = _data["department"];
            this.designation = _data["designation"];
            this.oldSalary = _data["oldSalary"];
            this.newSalary = _data["newSalary"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.incrementPercentage = _data["incrementPercentage"];
        }
    }

    static fromJS(data: any): EmployeeIncrementDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeIncrementDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["empLegalName"] = this.empLegalName;
        data["branch"] = this.branch;
        data["location"] = this.location;
        data["department"] = this.department;
        data["designation"] = this.designation;
        data["oldSalary"] = this.oldSalary;
        data["newSalary"] = this.newSalary;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["incrementPercentage"] = this.incrementPercentage;
        return data; 
    }
}

export interface IEmployeeIncrementDetailsDto {
    employee: EmployeeSummaryDto;
    empLegalName: string | undefined;
    branch: string | undefined;
    location: string | undefined;
    department: string | undefined;
    designation: string | undefined;
    oldSalary: number | undefined;
    newSalary: number | undefined;
    effectiveDate: Date | undefined;
    incrementPercentage: number | undefined;
}

